module.exports = __webpack_public_path__ + "img/document-filter.b98cfe94.svg";